tower.editLockCheckTimer = null
tower.editLockCheckXhr = null

pageId = 'page-doc'
page = '#' + pageId

$.extend tower,
  checkEditLock: (status) ->
    if status and !tower.editLockCheckTimer
      $page = $('#page-doc')
      tower.editLockCheckTimer = setInterval((->
        tower.checkEditLock false  if !$page.length
        $btn = $page.find('.detail-action-edit')
        tower.editLockCheckXhr = $.ajax(
          url: $btn.data('url')
          type: 'get'
          dataType: 'json'
          success: (result) ->
            if !result.is_locked
              tower.checkEditLock false
              $btn.addClass('hide').next('.detail-action-edit-real').removeClass 'hide'
          complete: ->
            tower.editLockCheckXhr = null
        )
      ), 30000)
    else if !status
      if tower.editLockCheckXhr
        tower.editLockCheckXhr.abort()
        tower.editLockCheckXhr = null
      clearInterval tower.editLockCheckTimer
      tower.editLockCheckTimer = null


$ ->
  tower.stack.on 'pageunload', (e, $page) ->
    $(window).off 'scroll', handleTocVertical

  $(document)
    .on 'click', "#{ page } #link-print-doc", ->
      $(document.body).addClass 'doc-print'
      window.print()
      setTimeout ->
        $(document.body).removeClass 'doc-print'
      , 1000

    .on 'ajax:beforeSend', "#{ page } .detail-action-del", ->
      simple.loading
        type: 'global'
        msg: '正在删除文档...'

    .on 'ajax:complete', "#{ page } .detail-action-del", ->
      simple.loading.destroy()

    .on 'click', "#{ page } .link-doc-diff", (e) ->
      e.preventDefault()
      $target = $(e.target)
      $content = $($('#tpl-doc-diff-popover').html())
      tower.adjustReadableTime $content
      simple.popover
        cls: 'doc-diff-popover'
        pointTo: $target
        content: $content
        position: 'right-bottom'

    .on 'click', '.popover-diff .version', (e) ->
      e.preventDefault()
      $target = $(e.currentTarget)
      popover = $target.closest('.simple-popover').data('popover')
      popover.pointTo.text '正在对比...'

    .on 'ajax:success', "#{ page } .link-diff, .popover-diff .link-diff", (e, result) ->
      popover = $(e.currentTarget).closest('.simple-popover').data('popover')

      if popover
        popover.pointTo.text '对比历史记录'
        popover.destroy()

      if result.success
        $target = $(e.target)
        $page = $('.page-inner')
        $content = $('#doc-content')
        titleEl = $('.doc-title')
        $versionInfo = $('.version-info')
        resetEl = $('.diff-info .reset')

        resetEl.trigger('click')  if resetEl.length
        titleEl.data('origin', titleEl.html())
          .html result.title_diff
        $content.data('origin', $content.html())
          .html("<div class='editor-style gallery-wrap'>#{result.content_diff}</div>")
          .addClass 'diff-content'

        $diffInfo = $("""
            <div class="diff-info hide"><div class="inr">
              正在和 #{$target.data('version-editor')} 于 #{$target.data('version-time')} 编辑的内容对比，
              <a href="javascript:;" class="reset">返回当前内容</a>
            </div></div>
          """)
        $versionInfo.slideUp()
        $diffInfo.appendTo($page).slideDown()

    .on 'click', "#{ page } .diff-info .reset", (e) ->
      e.preventDefault()
      $title = $('.doc-title')
      $content = $('#doc-content')
      $diffInfo = $('.diff-info')
      $versionInfo = $('.version-info')

      $title.html $title.data('origin')
      $content.html($content.data('origin'))
        .removeClass 'diff-content'
      $diffInfo.slideUp ->
        $diffInfo.remove()
      $versionInfo.slideDown()

    tower.stack.on 'pageunload', (e) ->
      tower.checkEditLock false

  $(document)
    .on 'click', "#{ page } #link-export-doc", ->
      # Change export button to waiting status.
      linkExportDoc = $("#link-export-doc")
      linkExportDoc.text("导出中...")
        .prop("disabled", true)
        .toggleClass("export-waiting")

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tocKey = $('#link-doc-toc').data 'toc-key'
  tocStatus = (simple.util.storage.get(tocKey) == 'true')

  $('#link-doc-toc').toc
    selectors: 'h1, h2, h3, h4, h5'
    container: $('#doc-content')
    status: tocStatus
    listTag: 'ol'
    placeholder: '无'
    onOpen: (list) ->
      unless $('.toc-wrapper').length
        $html = $('<div class="toc-wrapper"><p class="toc-title">目录</p><div class="toc-list"></div></div>')
        $html.find('.toc-list').html list
        $('#doc-content').prepend $html
        simple.util.storage.set tocKey, true

      $(this).text '关闭目录'

      $('.toc-list a').removeClass 'active'
      $(".toc-list a[href='#{location.hash}']").addClass 'active' if location.hash

      $('.toc-list a').on 'click', (e) ->
        $('.toc-list a').removeClass 'active'
        $(e.currentTarget).addClass 'active'

      handleTocVertical()
      $(window).on 'scroll', handleTocVertical
    onClose: ->
      $('.toc-wrapper').remove()
      simple.util.storage.set tocKey, false
      $(this).text '显示目录'
      $(window).off 'scroll', handleTocVertical

  tower.adjustAuthor()
  tower.adjustAttachment()
  tower.adjustProjInfo()
  tower.adjustCommentsLike()
  tower.foldComments()

  tower.foldEvents()
  tower.checkEditLock(true)  if $page.find('.detail-action-edit-real').hasClass('hide')


handleTocVertical = () ->
  return unless $(window).width() >= 1440

  scrollTop = $(window).scrollTop()
  $wrapper = $('.toc-wrapper')

  if scrollTop == 0
    $wrapper.css
      top: 165
      height: $(window).height() - 165

  else if scrollTop > 0 and scrollTop < 155
    currentTop = 160 - scrollTop
    $wrapper.css
      top: currentTop
      height: $(window).height() - currentTop

  else if scrollTop >= 155
    if $(document).height() - $(window).height() - scrollTop <= 90
      $wrapper.css
        top: 5
        height: $(window).height() - 90
    else
      $wrapper.css
        top: 5
        height: $(window).height() - 5
